import React, {Component} from 'react'
import {FaUpload} from "react-icons/fa";
import {FaPlus} from "react-icons/fa";

class DragDrop extends Component {
    state = {
        drag: false
    }
    dragOutTimer
    dragCounter = 0
    dropRef = React.createRef()
    handleDrag = (e) => {
        e.preventDefault()
        e.stopPropagation()
        ////console.log("handleDrag")
    }
    handleDragIn = (e) => {
        e.preventDefault()
        e.stopPropagation()
        ////console.log("handleDragIn")
        this.dragCounter++
        clearTimeout(this.dragOutTimer)
        if (e.dataTransfer && e.dataTransfer.types.includes("Files") && e.dataTransfer.items.length > 0) {
            //console.log(e.dataTransfer)
            this.setState({drag: true})
        }
        else{
            return false
        }
    }
    handleDragOut = (e) => {
        e.preventDefault()
        e.stopPropagation()
        ////console.log("handleDragOut")
        this.dragCounter--
        if (this.dragCounter === 0) {
            clearTimeout(this.dragOutTimer)
            if (e.dataTransfer && e.dataTransfer.items && e.dataTransfer.items.length > 0) {
                this.dragOutTimer = setTimeout(() => {
                    this.setState({drag: false})
                }, 50)
            }
        }
    }
    handleDrop = (e) => {
        e.preventDefault()
        e.stopPropagation()
       // //console.log("handleDrop")
        this.setState({drag: false})
        if (e.dataTransfer && e.dataTransfer.files && e.dataTransfer.files.length > 0) {
            this.props.handleDrop(e.dataTransfer.files)
            //e.dataTransfer.clearData()
            this.dragCounter = 0
        }
    }

    componentDidMount() {
        let div = this.dropRef.current
        div.addEventListener('dragenter', this.handleDragIn)
        div.addEventListener('dragleave', this.handleDragOut)
        div.addEventListener('dragover', this.handleDrag)
        div.addEventListener('drop', this.handleDrop)
    }

    componentWillUnmount() {
        let div = this.dropRef.current
        div.removeEventListener('dragenter', this.handleDragIn)
        div.removeEventListener('dragleave', this.handleDragOut)
        div.removeEventListener('dragover', this.handleDrag)
        div.removeEventListener('drop', this.handleDrop)
    }

    render() {
        const opacity = this.state.drag ? "invisible":""
        return (
            <div
                ref={this.dropRef}
                className="position-relative"
                style={this.props?.style}
            >
                <div className={`position-relative ${opacity}`} style={{zIndex:2}}>
                    {this.props.children }
                </div>
                <div className="d-flex position-absolute w-100" style={{top:"35%",zIndex:0}}>
                    <div className="h-100 align-items-center mx-auto  text-center">
                        <div className="d-inline-flex">
                        {this.state.drag &&
                        <FaPlus size={100} color="#f6f6f6"/>
                        }
                        {!this.state.drag &&
                        <FaUpload size={100} color="#f6f6f6"/>
                        }
                        </div>
                        <div  style={{color: "#f6f6f6",zIndex:0}}>Drop files here</div>
                    </div>
                </div>
            </div>
        )
    }
}

export default DragDrop
